import meetingInsightsCache from '../store/schema/meetingInsightsCache';
import { setMeetingInsights } from '../actions/internalActions';
import { orchestrator } from 'satcheljs';

export let setMeetingInsightsOrchestrator = orchestrator(setMeetingInsights, actionMessage => {
    const {
        meetingId,
        status,
        files,
        emails,
        traceId,
        dataFetchSource,
        requestTimestamp,
        logicalId,
    } = actionMessage;
    meetingInsightsCache.add(meetingId, {
        files: files,
        emails: emails,
        serviceRequestStatus: status,
        requestTimestamp: requestTimestamp,
        logicalId: logicalId,
        traceId: traceId,
        dataFetchSource: dataFetchSource,
    });
});
